import React, { useMemo } from 'react';
import { Field, useField } from 'react-final-form';

import useAIMediaOptions from './useAIMediaOptions';
import AccessContainers from '../../../components/access-containers/AccessContainers';

function AIMediaContainer({ search = '', fieldName = 'assignedAIMedia', disabled }) {
  const assignedAIMediaField = useField(fieldName);

  const { options: aiMediaOptions, isLoading } = useAIMediaOptions({ search });

  const handleRemoveAIMedia = (aiMedia) => {
    assignedAIMediaField.input.onChange(assignedAIMediaField.input.value.filter((a) => a.id !== aiMedia.id));
  };

  const handleAssignAIMedia = (aiMedia) => {
    assignedAIMediaField.input.onChange([...assignedAIMediaField.input.value, aiMedia]);
  };

  const inactiveAIMedia = useMemo(
    () =>
      aiMediaOptions.filter(
        (aiChat) => !assignedAIMediaField.input.value.some((activeAIChat) => activeAIChat.id === aiChat.id),
      ),
    [assignedAIMediaField.input.value, aiMediaOptions],
  );

  return (
    <Field name={fieldName}>
      {({ input }) => (
        <AccessContainers
          onInactive={handleRemoveAIMedia}
          onActive={handleAssignAIMedia}
          inactive={inactiveAIMedia}
          active={input.value}
          disabled={disabled}
          isLoading={isLoading}
          searchStr={search}
        />
      )}
    </Field>
  );
}

export default AIMediaContainer;
